import { defineComponent as _defineComponent } from 'vue'

import { defineComponent } from '@nuxtjs/composition-api';

const __default__ = defineComponent({
  // @ts-ignore
  head() {
    const i18nHead = this.$nuxtI18nHead({ addSeoAttributes: true });
    const { googleGtagId } = this.$config;
    const scripts = [];
    const favicon = this.$store.getters['config/getFavicon'];

    if (googleGtagId)
      scripts.push({
        src: `https://www.googletagmanager.com/gtag/js?id=${googleGtagId}`,
        async: true,
      });

    const getAppFaviconLink = () => {
      return {
        rel: 'icon',
        type: 'image/x-icon',
        href: this.$config.joinuApp
          ? '/joinu-favicon.ico'
          : favicon ?? '/favicon.ico',
      };
    };

    return {
      title: 'Prestigio solutions',
      htmlAttrs: {
        ...i18nHead.htmlAttrs,
      },
      bodyAttrs: {
        class: 'theme-prsol',
      },
      meta: [...i18nHead.meta],
      link: [getAppFaviconLink(), ...i18nHead.link],
      script: scripts,
    };
  },
});

import { computed } from 'vue';
import { useContext, useStore } from '@nuxtjs/composition-api';

import { usePagePreloader } from '~/composables';
import AppHeader from '@/components/AppHeader.vue';
import AppFooter from '@/components/AppFooter.vue';
import AppTopbar from '@/components/AppTopbar.vue';
import { AppMenu } from '@webplatform/frontkit/dist/store/menus';
import AppUpButton from '@/components/AppUpButton.vue';
import ChatBot from '~/components/ChatBot.vue';


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'default',
  setup(__props) {

const { route } = useContext();
const store = useStore();
const pagePreloader = usePagePreloader();

const isHomepage = computed(() => route.value?.fullPath === '/');

const menuTop: AppMenu[] = store.getters['menus/menuTop'];
const menuMain: AppMenu[] = store.getters['menus/menuMain'];
const menuFooter: AppMenu[] = store.getters['menus/menuFooter'];
const menuBottom: AppMenu[] = store.getters['menus/menuBottom'];

return { __sfc: true,route, store, pagePreloader, isHomepage, menuTop, menuMain, menuFooter, menuBottom, AppHeader, AppFooter, AppTopbar, AppUpButton, ChatBot }
}

})